module.exports = __webpack_public_path__ + "static/media/notification.a90b8d5c.mp3";